export const BASE_URL = `https://asia-south1-${process.env.REACT_APP_PROJECT_ID}.cloudfunctions.net/`;

